import { clearActionsDone } from '@/store/utilities/actionsDone';
import { clearBudgetCache } from '@/store/utilities/budget-cache';

// Also listed in elsa-v3/src/utils/customerStorage.ts (VUE2_KEYS)
export const ADVISORY_ANSWERS_KEY = 'advisory-questions';

export function clearCustomerStorage() {
  clearActionsDone();
  clearBudgetCache();
  try {
    localStorage.removeItem(ADVISORY_ANSWERS_KEY);
  } catch (error) {
    // Storage unavailable: nothing is stored
  }
}
